// Version : 0.0.1
// Author : SABARI
// LastEdit : SABARI
// Last ADD : Add, Update, Delete.
// MODIFIED DATE : 14-08-2025

import { makeApiCall } from '../../../_common/api.utils';
import { FIN_API_URL } from '../../../const';

/***********  CREATE GROUP ACCOUNT DETAILS START *************** */
export const GroupAccountCreate = (addData: any) => {
	const data = {
		CreateGroupAccountListToken: addData,
	};
	const url = `${FIN_API_URL}createNewGroupAccount`;
	return makeApiCall(url, data);
};
/***********  CREATE GROUP ACCOUNT DETAILS END *************** */

/*** GET GROUP ACCOUNT LIST START ***/
export const GroupAccountListGet = (GrouplistData: any) => {
	const data = {
		GetGroupAccountListToken: GrouplistData,
	};
	const url = `${FIN_API_URL}getAllGroupAccountList`;
	return makeApiCall(url, data);
};
/*** GET GROUP ACCOUNT LIST END ***/

/*** GET PRIMARY ACCOUNT LIST START ***/
export const PrimaryAccountListGet = (PrimarylistData: any) => {
	const data = {
		GetPrimaryAccountListToken: PrimarylistData,
	};
	const url = `${FIN_API_URL}getAllPrimaryAccountList`;
	return makeApiCall(url, data);
};
/***********  GET PRIMARY ACCOUNT LIST END *************** */

/*** GET PARTICULAR GROUP ACCOUNT LIST START ***/
export const ParticularGroupDetailsFetch = (listData: any) => {
	const data = {
		GetParticularAccountListToken: listData,
	};
	const url = `${FIN_API_URL}getParticularGroupAccount`;
	return makeApiCall(url, data);
};
/***********  GET PARTICULAR GROUP ACCOUNT LIST END *************** */

/*** UPDATE GROUP ACCOUNT LIST START ***/
export const GroupAccountUpdate = (UpdateData: any) => {
	const data = {
		UpdateGroupAccountListToken: UpdateData,
	};
	const url = `${FIN_API_URL}updateGroupAccount`;
	return makeApiCall(url, data);
};
/*********** UPDATE GROUP ACCOUNT LIST END *************** */

/*** DELETE GROUP ACCOUNT LIST START ***/
export const GroupAccountDelete = (DeleteData: any) => {
	const data = {
		DeleteGroupAccountListToken: DeleteData,
	};
	const url = `${FIN_API_URL}deleteGroupAccount`;
	return makeApiCall(url, data);
};
/*********** DELETE GROUP ACCOUNT LIST END *************** */

/*** ALL GROUP ACCOUNT EXPORT START ***/
export const AllGroupAccountExportService = (exportData: any) => {
	const data = {
		AllGroupAccountExportToken: exportData,
	};
	const url = `${FIN_API_URL}exportAllGroupAccounts`;
	return makeApiCall(url, data);
};
/*** ALL GROUP ACCOUNT EXPORT END ***/
